import { DropdownMenu } from 'radix-ui';

import DropdownItem from './DropdownItem';

import type { DropdownItemProps } from './DropdownItem';

type Props = DropdownItemProps;

const FilterButtonCheckboxItem = ({
  checked,
  count,
  label,
  labelSubtitle,
  onCheckedChange,
  showArrow
}: Props) => {
  return (
    <DropdownMenu.CheckboxItem
      asChild={true}
      checked={checked}
      onCheckedChange={onCheckedChange}
      onSelect={(ev) => ev.preventDefault()}
      onPointerMove={(ev) => ev.preventDefault()}
      onPointerLeave={(ev) => ev.preventDefault()}
    >
      <DropdownItem
        checked={checked}
        count={count}
        countCategory="dark"
        label={label}
        labelSubtitle={labelSubtitle}
        showArrow={showArrow}
        withCheckbox={true}
      />
    </DropdownMenu.CheckboxItem>
  );
};

export default FilterButtonCheckboxItem;
